import sensors from 'sa-sdk-javascript';
import { isApp } from '.';
import { getSensorOrigin } from './origin';

export type TrackEvent = 'IM_Click' | 'IM_PV' | string | undefined;
export interface TrackParams {
  button_type?: string;
  page_type?: '聊天页' | '订单选择页' | string;
  business_type?: string;
  [key: string]: string | undefined;
}

class Sensor {
  private from?: string;

  private userType?: string;

  private channelid?: string;

  private trackQueue: Array<() => void> = [];

  private hasLogin = false;

  private fromPageId?: string;

  private getUrl(userType?: string) {
    const projectMap: { [key: string]: string } = {
      '30': 'xldriver',
      '31': 'xluser'
    };
    const project = userType ? projectMap[userType] || 'xluser' : 'xluser';

    return getSensorOrigin(project);
  }

  private getPlatform() {
    const from = this.from || '未知';
    let platform = '未知';
    const platformDict: { [key: string]: string } = {
      xlaWeixinApp: '微信小程序',
      xlaAlipayApp: '支付宝小程序',
      xlaCainiaoApp: '菜鸟裹裹小程序',
      xlaBaiduApp: '百度小程序',
      xlaLightApp: '轻应用',
      xlaDouyinApp: '抖音小程序',
      xlaH5: '小拉H5',
      xlaHarmonyMetaApp: '鸿蒙元服务'
    };
    if (isApp() || ['xlaUApp', 'xlaDApp'].includes(from)) {
      platform = /(iPad|iPhone|iPod)/g.test(window.navigator.userAgent) ? 'ios' : 'android';
    } else {
      platform = platformDict[from] || this.channelid || '未知';
    }
    return platform;
  }

  init(from?: string, channelid?: string, userType?: string, fromPageId?: string) {
    this.from = from;
    this.channelid = channelid;
    this.userType = userType;
    this.fromPageId = fromPageId;
    sensors.init({
      server_url: this.getUrl(userType), // 替换成自己的神策地址
      heatmap: {
        // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        clickmap: 'not_collect',
        show_log: false, // 打印console，自己配置，可以看到自己是否踩点成功，以及
        // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        scroll_notice_map: 'not_collect'
      },
      show_log: false,
      // 单页面中的页面浏览事件采集($pageview)
      // is_track_single_page:true,
      send_type: 'beacon'
    });
  }

  login(userId: string) {
    sensors.login(userId);
    this.hasLogin = true;
    while (this.trackQueue.length > 0) {
      const cb = this.trackQueue.shift();
      if (cb) {
        cb();
      }
    }
  }

  track(eventName: TrackEvent = 'IM_Click', params: TrackParams = {}) {
    if (!this.hasLogin) {
      this.trackQueue.push(() => this.track(eventName, params));
      return;
    }
    const paramsData = {
      platform_type: this.getPlatform(), // 平台类型
      from_page_id: this.fromPageId,
      ...params
    };
    sensors.track(eventName, paramsData);
  }
}

const sensor = new Sensor();

export default sensor;
